import styled from "styled-components";
import * as zero from '@zero/design-tokens/build/js/variables'


export const StyledDate = styled.span`
    font-family: ${zero.ZrFontFamilyDigitalRegular};
`